import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import { useLocation } from "react-router-dom";
import CustomHeading from "../../components/common/CustomHeading";
import ProspectPropertyService from "../Service/ProspectPropertyService";

const AttachmentsListPage = () => {
  const location = useLocation();
  const { propertyName, prospectPropertyId } = location.state || {};
  const [data, setData] = useState({ attachments: [] });
  const [activeTab, setActiveTab] = useState("Advocate Analysis");
  const [loading, setLoading] = useState(false);

  const tabs = [
    { value: "Advocate Analysis", label: "Advocate Analysis" },
    { value: "Query", label: "Queries" },
  ];

  const fetchData = async (tabType) => {
    setLoading(true);
    setData({ attachments: [] }); // Clear previous data immediately
    try {
      const response = await ProspectPropertyService.getPropertyDocumentList({
        prospectPropertyId,
        type: tabType,
      });
      setData(response.data?.data || { attachments: [] });
    } catch (error) {
      console.error("Error fetching document list", error);
      setData({ attachments: [] });
    } finally {
      setLoading(false);
    }
  };

  const handleTabChange = (tabType) => {
    setActiveTab(tabType);
  };

  useEffect(() => {
    fetchData(activeTab);
  }, [activeTab]);

  return (
    <div>
      <Header />
      <div className="pt-28 px-6">
        <CustomHeading title={propertyName} isIcon={true} />

        <div className="p-5 bg-white rounded-lg shadow mt-7">
          {/* Tabs */}
          <div className="flex space-x-4 border-b mb-4">
            {tabs.map((tab) => (
              <button
                key={tab.value}
                onClick={() => handleTabChange(tab.value)}
                className={`px-4 py-2 font-medium text-base transition-colors duration-200 border-b-2 ${
                  activeTab === tab.value
                    ? "border-customGreen text-customGreen"
                    : "border-transparent text-gray-500 hover:text-gray-700"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Documents */}
          <div className="mt-6 h-[400px] overflow-auto">
            {loading ? (
              <div className="text-center py-8">Loading...</div>
            ) : data.attachments.length ? (
              <div className="space-y-4">
                {data.attachments.map((attachment, index) => {
                  const isQuery = activeTab === "Query";

                  // Title & Subtitle
                  const displayTitle = attachment?.type === "responseFileUrl" ? "Response Legal Opinion" : "Legal Opinion"
                  const displaySubtitle = isQuery ? attachment.category : null;

                  return (
                    <div
                      key={attachment.id + index}
                      className="flex items-center justify-between p-4 border border-gray-200 rounded-lg hover:bg-gray-50"
                    >
                      <div className="flex items-center space-x-3">
                        <div className="flex-shrink-0">
                          <svg
                            className="h-8 w-8 text-red-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                        <div>
                            {!isQuery && (
 <div className="text-sm font-medium text-gray-900">
                            {displayTitle}
                          </div>
                            )}
                         
                          {displaySubtitle && (
                            <div className="text-sm text-gray-500">Category : {displaySubtitle}</div>
                          )}
                        </div>
                      </div>

                      <div className="flex space-x-2">
                        {attachment.url && (
                          <button
                            onClick={() => window.open(attachment.url, "_blank")}
                            className="inline-flex items-center px-3 py-1 border border-transparent text-xs font-medium rounded text-blue-600 bg-blue-100 hover:bg-blue-200"
                          >
                            View
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div className="text-center py-8">
                <svg
                  className="mx-auto h-12 w-12 text-gray-400"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
                <h3 className="mt-2 text-sm font-medium text-gray-900">No documents found</h3>
                <p className="mt-1 text-sm text-gray-500">
                  No {activeTab === "Query" ? "query" : "advocate analysis"} documents available for this property.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttachmentsListPage;
